import IonIcon from '@reacticons/ionicons'
import Link from 'next/link'
import React from 'react'
import Modal from 'react-modal'

interface SignUpModalProps {
  isOpen: boolean
  page?: string
  params?: string
  onClose: () => void
}

const ModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0px',
    transform: 'translate(-50%, -50%)',
    borderWidth: '0px',
    backgroundColor: 'transparent',
    border: '0px solid red',
  },
}

export const SignUpModal: React.FC<SignUpModalProps> = ({ isOpen, page, params, onClose }) => {
  const handleClose = () => {
    onClose()
  }

  return (
    <Modal closeTimeoutMS={200} isOpen={isOpen} onRequestClose={handleClose} style={ModalStyles} ariaHideApp={false}>
      <div className="flex flex-col md:w-[510px] w-full pl-[15px] md:px-0">
        <div className="flex flex-row w-full z-10">
          <div className="ml-auto cursor-pointer text-textdark relative" onClick={handleClose}>
            <div className="w-4 h-4 m-2 rounded-md bg-white absolute z-20"></div>
            <IonIcon name="close-circle" className="!h-[30px] !w-[30px] relative z-30" />
          </div>
        </div>

        <div className="flex flex-col overflow-y-hidden mt-[-25px] mr-[15px]">
          <div className="bg-white rounded-[5px] flex flex-row w-full">
            <div className="flex flex-col w-full">
              <div className="h-2 bg-navy rounded-t-[5px]"></div>
              <div className="flex flex-col py-10 px-5 md:p-12 text-[16px] font-primary text-darkgray">
                <p className="flex text-[30px] font-bold font-secondary text-navy">Sign Up</p>
                <div className="flex flex-wrap my-[15px]">
                  <p>
                    Sign up for an <b>account</b> at no cost so you can easily follow your favourite solutions,
                    subtopics and compare solutions.
                  </p>
                </div>
                <div>
                  <p className="text-white font-secondary text-[14px] font-bold text-center rounded-[22.5px] px-[25px] bg-navy w-[206px] h-[45px] my-[15px] items-center justify-center flex">
                    <Link href={{ pathname: '/signup', query: { page: page, params: params } }}>Create an account</Link>
                  </p>
                </div>
                <div className="flex flex-col md:flex-row mt-[25px] mb-[15px]">
                  Have an account?
                  <p className="font-bold font-primary text-textdark underline md:ml-1">
                    <Link href={{ pathname: '/signin' }}>Sign in</Link>
                  </p>
                </div>
                <div className="flex flex-col md:flex-row mb-[12px]">
                  Are you a vendor?
                  <p className="font-bold font-primary text-textdark underline md:ml-1">
                    <Link href="/requestvendor">Vendor Information</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
